import React from "react";
import { isTotallessGroupColumn } from "../value-getters";
import { numberFormatters } from "common";
import { NumberFormatKind } from "common/types";
const maximumPossibleMaximumFractionDigits = 17;
export const NumberCellRenderer = (props) => React.createElement("span", { className: props.node.group ? "is-total-row" : "" }, isTotallessGroupColumn(props) ? "" : numberFormatters(props.value, NumberFormatKind.default, { maximumFractionDigits: maximumPossibleMaximumFractionDigits }));
